module.exports = __webpack_public_path__ + "img/popup-top-logo.bf9bacbd.png";